export default __webpack_public_path__ + "static/orangeRing-a1c8900d81343d54db42878d06c58688.png";